import { ExternalMain } from "../components/Main";

export default function History() {
    return(
        <ExternalMain pageName="History"/>
    )
}
